import {Component, inject, OnInit} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {NgSelectConfig} from '@ng-select/ng-select';

@Component({
    // tslint:disable-next-line
    selector: 'body',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private selectConfig = inject(NgSelectConfig);

  constructor() {
      // @ng-select/ng-select configuration
      this.selectConfig.placeholder = 'Seleziona';
      this.selectConfig.notFoundText = 'Elementi non trovati';
      this.selectConfig.addTagText = 'Aggiungi';
      this.selectConfig.typeToSearchText = 'Scrivi per cercare';
      this.selectConfig.loadingText = 'Caricamento...';
      this.selectConfig.clearAllText = 'Rimuovi tutto';
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }
}
